import Component from '../abstracts/Component';
import {doAjax} from '../utils/ajaxUtil';
import {IS_PRIVACY_PAGE} from '../utils/Environment';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      miniCart: '.js-minicart',
      quickCart: '[data-quick-cart]',
      remove: '.js-removeitem',
    }
  }

  constructor() {
    super();
    this.timeout = null;
    this.updateMiniCartBtn = $(this.SELECTORS.miniCart);
    this.quickCart = $(this.SELECTORS.quickCart);
  }

  updateMinicart() {
    let self = this;
    let $elem = self.updateMiniCartBtn;
    let $replace = self.quickCart;

    return doAjax({
      url: $elem.data('url'),
      dataType: "html",
      success: function (resp) {
        self.log('Minicart updated...');
        let response = new DOMParser().parseFromString(resp, 'text/html');
        $replace.html(response.querySelector('.l-quick-cart').innerHTML);
        // update cart counter
        self.updateQty();
        // trigger event
        self.$emit(self.$customEvents.MINICART_EVENTS.update, {quick: $replace});
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  updateQty() {
    let qty = this.quickCart.find('.l-q-c__title').data('mcqty');
    // desktop
    if(this.updateMiniCartBtn != null) {
      this.updateMiniCartBtn.find('.icon-box__dot').attr('data-mcqty', qty);
    }
    if(qty > 0) {
  	  this.updateMiniCartBtn.find('.icon-box__dot').removeClass('hidden');
  	  this.quickCart.removeClass('empty');
    } else {
      this.updateMiniCartBtn.find('.icon-box__dot').addClass('hidden');
      this.quickCart.addClass('empty');
    }
  }

  removeProduct(el) {
    let self = this;
    let $elem = $(el);
    let $main = $elem.closest(self.SELECTORS.quickCart);

    doAjax({
      url: $elem.data('href'),
      dataType: "json",
      type: 'POST',
      success: function (resp) {
        let item = $elem.closest('.product-item');
        let qty = resp.count;
        let tot = resp.totalFormattedPrice;

        setTimeout(() => {
          item.remove();
        }, 800);
        $main.find('.tot-price').text(tot);

        self.updateMinicart();

        if(resp.count > 0) {
          self.container.find('.qty-icon').text(qty);
        }
        self.updateMinicart();
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  bindEvents() {
    let self = this;
    $('body').on('click.removeProduct', self.SELECTORS.remove, function() {
      self.removeProduct(this);
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    if(!IS_PRIVACY_PAGE) {
      this.updateMinicart();
    }
  }
}
